// cancellationsListSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../apiSlice";
import { buildQueryString } from "../../utils/buildQueryString";

/* =========================
   Adapter
========================= */

const cancellationsAdapter = createEntityAdapter({
  selectId: (cancellation) => cancellation.id,
});

const initialState = cancellationsAdapter.getInitialState();

/* =========================
   API Slice
========================= */

export const cancellationsListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    /* -------- GET CANCELLATIONS LIST -------- */
    getCancellationsList: builder.query({
      query: (filters = {}) =>
        buildQueryString("cancelled_orders", filters),

      transformResponse: (response) => {
        const normalized = (response.data ?? []).map((item) => ({
          ...item,
        }));

        return cancellationsAdapter.setAll(initialState, normalized);
      },

      providesTags: (result) => [
        { type: "Cancellations", id: "LIST" },
        ...(result?.ids ?? []).map((id) => ({
          type: "Cancellations",
          id,
        })),
      ],
    }),

    /* -------- GET CANCELLATION BY ID -------- */
    getCancellationById: builder.query({
      query: (cancellationId) =>
        `cancelled_orders/${cancellationId}`,

      transformResponse: (response) =>
        response?.data ?? null,

      providesTags: (result, error, id) => [
        { type: "Cancellations", id },
      ],
    }),

    /* -------- PATCH CANCELLATION STATUS (optional) -------- */
    // patchCancellationStatus: builder.mutation({
    //   query: ({ id, order_status, remarks }) => ({
    //     url: `cancelled_orders/${id}`,
    //     method: "PATCH",
    //     body: { order_status, ...(remarks && { remarks }) },
    //   }),
    //
    //   invalidatesTags: (result, error, { id }) => [
    //     { type: "Cancellations", id },
    //     { type: "Cancellations", id: "LIST" },
    //   ],
    // }),

  }),
});

/* =========================
   Hooks
========================= */

export const {
  useGetCancellationsListQuery,
  useGetCancellationByIdQuery,
  // usePatchCancellationStatusMutation,
} = cancellationsListSlice;


/* =========================
   Filter Selector
========================= */

const selectCancellationFilter = (state) =>
  state.cancellationFilter;


/* =========================
   Query Arg Selector (STANDARD)
========================= */

export const selectCancellationQueryArg = createSelector(
  [selectCancellationFilter],
  (filter) => ({
    status: filter.status,
    search: filter.search,
  })
);


/* =========================
   Query Result Selector
========================= */

const selectCancellationQueryResult = createSelector(
  [selectCancellationQueryArg, (state) => state],
  (filters, state) =>
    cancellationsListSlice.endpoints
      .getCancellationsList
      .select(filters)(state)
);


/* =========================
   Data Selector
========================= */

const selectCancellationData = createSelector(
  [selectCancellationQueryResult],
  (queryResult) => queryResult?.data ?? initialState
);


/* =========================
   Adapter Selectors
========================= */

export const {
  selectAll: selectCancellations,
  selectById: selectCancellationById,
  selectIds: selectCancellationIds,
} = cancellationsAdapter.getSelectors((state) =>
  selectCancellationData(state)
);